import React, { Component } from "react";
import eye from "../assets/eye.svg";
import eyeClosed from "../assets/eyeClosed.svg";

export default class ServiceInput extends Component {
  state = {
    type: this.props.type,
    "data-index": 0,
  };
  toggle_show = () => {
    const type = this.state.type === "password" ? "text" : "password";
    this.setState({
      type,
    });
  };
  showPasswordTypeSvg = () =>
    this.state.type === "password" ? (
      <img src={eye} alt="" srcset="" />
    ) : (
      <img src={eyeClosed} alt="" srcset="" />
    );
  showPasswordButton = () => {
    if (this.props.type === "password") {
      return (
        <button type="button" className="abs_btn" onClick={this.toggle_show}>
          {this.showPasswordTypeSvg()}
        </button>
      );
    }
  };

  dataList = () => {
    if (this.props.dataList) {
      return (
        <datalist id={this.props.label}>
          {this.props.dataList.map((item, index) => (
            <option value={item.name} data-index={index}>
              {item.name}
            </option>
          ))}
        </datalist>
      );
    }
  };
  onChangeAction = (ev) => {
    if (this.props.onChangeAction) {
      this.props.onChangeAction(ev.currentTarget.value);
    } else if (this.props.onChange) {
       
      this.props.onChange(ev);
      var selected_input_id = ev.currentTarget.id;
      let class_names = ev.currentTarget.className;
      let checker = class_names.includes("starttime");
      let checker_end = class_names.includes("endtime");
      if (checker) {
        var select_input_end = document.getElementsByClassName(
          selected_input_id + "_end"
        )[0];
         

        let date_new = this.parseTime(ev.currentTarget.value, 8);
        // select_input_end.min = date_new;
        select_input_end.value = date_new;
      } else if (checker_end) {
        // if time enter is no lower than start time
        var select_input_start = document.getElementsByClassName(
          selected_input_id + "_start"
        )[0];
        var select_input_end = document.getElementsByClassName(
          selected_input_id + "_end"
        )[0];
        let start_stamp = this.timeToStamp(select_input_start.value);
        let end_stamp = this.timeToStamp(select_input_end.value);

        if (end_stamp <= start_stamp) {
          //  alert("Closing hour can't be lower than Opening hour  ");
          let date_new = this.parseTime(select_input_start.value, 1);
          // select_input_end.min = date_new;
          select_input_end.value = date_new;
          this.props.onChange(ev);
        }
      }
    }
  };

  parseTime = (t, h) => {
    var d = new Date();
    var time = t.match(/(\d+)(?::(\d\d))?\s*(p?)/);
    if (time) {
      d.setHours(parseInt(time[1]) + (time[3] ? 12 : 0));
      d.setMinutes(parseInt(time[2]) || 0);

      d.setTime(d.getTime() + h * 60 * 60 * 1000);
      return d.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: false,
      });
    }
    //  return localeSpecificTime.replace(/:\d+ /, ' ');
  };

  timeToStamp = (t) => {
    var d = new Date();
    var time = t.match(/(\d+)(?::(\d\d))?\s*(p?)/);
    if (time) {
      d.setHours(parseInt(time[1]) + (time[3] ? 12 : 0));
      d.setMinutes(parseInt(time[2]) || 0);

      return d.getTime();
    }
  };

  error = () =>
    this.props.error ? <p className="err">{this.props.error}</p> : "";

  render() {
    return (
      <div className="input-rapper" {...this.props}>
        <p
          className="label"
          style={{ opacity: this.props.hidelabel ? "0" : "1" }}
        >
          {this.props.label}
        </p>

        <input
          {...this.props}
          id={this.props.id}
          dataList={false}
          type={this.state.type}
          autoFocus={this.props.autoFocus ? true : false}
          list={this.props.label}
          onChange={this.onChangeAction}
          value={this.props.value !== undefined ? this.props.value : ""}

          inputMode={this.props.type === "number" ? "numeric" : undefined}
          pattern={this.props.type === "number" ? "[0-9]*" : undefined}
        />
        {this.dataList()}
        {this.showPasswordButton()}
        {this.error()}
      </div>
    );
  }
}
